import { render, staticRenderFns } from "./DecorationIndex.vue?vue&type=template&id=b9dfb7f2&scoped=true&"
import script from "./DecorationIndex.vue?vue&type=script&lang=js&"
export * from "./DecorationIndex.vue?vue&type=script&lang=js&"
import style0 from "./DecorationIndex.vue?vue&type=style&index=0&id=b9dfb7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dfb7f2",
  null
  
)

export default component.exports